
var vars = require('./variables');

/**
 * jCube Core
 */
var jCube = function( selector, context ) {
    return new jCube.fn.init( selector, context );
};


jCube.h = {};

/**
 * $(selector).method()
 * jCube.prototype for correct instanceof jCube
 */
jCube.fn = jCube.prototype = {
    constructor: jCube,
    version: vars.version,
    selector: "",
    length: 0,

    init: function( selector, context ) {
        
        if (context === void 0) {
            context = vars.doc;
        }

        if (!selector) return this;

        if (jCube.isCubeJS(selector)) return selector;

        var eles = selector;
        if (jCube.isString(selector)) {
            var ctx = jCube.isCubeJS(context) ? context[0] : context;
            eles = vars.idRe.test(selector) ? ctx.getElementById(selector.slice(1)) : vars.htmlRe.test(selector) ? parseHTML(selector) : jCube.find(selector, ctx);
            if (!eles) return;
        }

        if (eles.nodeType || eles === vars.win) eles = [eles];

        this.length = eles.length;
        this.selector = selector;

        for (var i = 0, l = this.length; i < l; i++) {
            this[i] = eles[i];
        }

        return this;
    },

    // toArray: function() {
    //     return slice.call( this );
    // },
    //
    // eq: function( index ) {
    //     return jCube(this.get(index));
    // },
    //
    // is: function (comparator) {
    //     if (!comparator || !this[0]) return false;
    //     var compare = jCube.h.getCompareFunction(comparator);
    //     var check = false;
    //     this.each(function (i, ele) {
    //         check = compare.call(ele, i, ele);
    //         return !check;
    //     });
    //     return check;
    // },
    //
    // not: function (comparator) {
    //     if (!comparator || !this[0]) return this;
    //     var compare = jCube.h.getCompareFunction(comparator);
    //     return this.filter(function (i, ele) {
    //         return !compare.call(ele, i, ele);
    //     });
    // },
    //
    // end: function() {
    //     return this.prevObject || this.constructor(null);
    // },



    prop: function (prop, value) {
        if (!prop) return this;

        jCube.each(this, function (i, obj) {
            obj[prop] = value;
        });
    },

    attr: function (attr, value) {
        if (!attr) return;

        if (jCube.isString(attr)) {
            if (arguments.length < 2) {
                if (!this[0]) return this;

                var value_1 = this[0].getAttribute(attr);
                return value_1 === null ? undefined : value_1;
            }

            if (value === undefined) return this;

            if (value === null) return this.removeAttr(attr);

            jCube.each(this, function (index, element) {
                element.setAttribute(attr, value);
            });

            return this;
        }

        for (var key in attr) {
            this.attr(key, attr[key]);
        }

        return this;
    },

    text: function (text) {
        if (text === undefined) return this[0] ? this[0].textContent : '';

        return this.each(function (i, ele) {
            ele.textContent = text;
        });
    },

    removeAttr: function (attr) {
        var attrs = jCube.h.getSplitValues(attr);
        if (!attrs.length) return this;
        return this.each(function (i, ele) {
            each(attrs, function (i, a) {
                ele.removeAttribute(a);
            });
        });
    },

    append: function () {
        var _this = this;

        each(arguments, function (i, selector) {
            jCube.h.insertContent(_this, jCube(selector));
        });

        return this;
    },

    appendTo: function (selector) {
        jCube.h.insertContent(selector, this);

        return this;
    },

    detach: function () {
        return this.each(function (i, ele) {
            if (ele.parentNode) {
                ele.parentNode.removeChild(ele);
            }
        });
    },

    remove: function () {
        return this.each(function (i, ele) {
            if (ele.parentNode) {
                ele.parentNode.removeChild(ele);
            }
        });
    },

    insertAfter: function (selector) {
        var _this = this;

        jCube(selector).each(function (index, ele) {
            var parent = ele.parentNode;

            if (parent) {
                _this.each(function (i, e) {
                    jCube.h.insertElement(parent, !index ? e : e.cloneNode(true), true, ele.nextSibling);
                });
            }
        });
        return this;
    },

    css: function (prop, value) {
        if (jCube.isString(prop)) {
            var isVariable_1 = jCube.isCSSVariable(prop);
            prop = jCube.getPrefixedProp(prop, isVariable_1);

            if (arguments.length < 2) return this[0] && jCube.computeStyle(this[0], prop, isVariable_1);
            if (!prop) return this;

            value = jCube.getSuffixedValue(prop, value, isVariable_1);

            this.each(function (i, ele) {
                if (!jCube.isElement(ele)) return;

                if (isVariable_1) {
                    ele.style.setProperty(prop, value); //TSC
                } else {
                    ele.style[prop] = value; //TSC
                }
            });

            return this;
        }

        for (var key in prop) {
            this.css(key, prop[key]);
        }

        return this;
    },

    height: function() {

        if (arguments.length < 1){
            return this.length ? jCube.computeStyle(this[0], 'height') : undefined;
        }

        // TODO: Add value
    },

    // scrollLeft: "pageXOffset",
    // scrollTop: "pageYOffset"
    // scrollElement( elem, method, prop, val )

    scrollLeft: function( val ) {

    },

    scrollTop: function( val ) {
        if(!this.length) return this;

        return jCube.scrollElement( this[0], 'scrollTop', 'pageYOffset', val );
    },

    // hasClass: function (cls) {
    //     return cls && vars.some.call(this, function (ele) {
    //         return ele.classList.contains(cls);
    //     });
    // },
    //
    // toggleClass: function (cls, force) {
    //     var classes = jCube.h.getSplitValues(cls),
    //         isForce = force !== undefined;
    //     if (!classes.length) return this;
    //     this.each(function (i, ele) {
    //         jCube.each(classes, function (i, c) {
    //             if (isForce) {
    //                 force ? ele.classList.add(c) : ele.classList.remove(c);
    //             } else {
    //                 ele.classList.toggle(c);
    //             }
    //         });
    //     });
    //
    //     return this;
    // },
    //
    // addClass: function (cls) {
    //     return this.toggleClass(cls, true);
    // },
    //
    // removeClass: function (cls) {
    //     return !arguments.length ? this.attr('class', '') : this.toggleClass(cls, false);
    // },

    focus: function() {
        if( !this.length ) return this;

        this[0].focus();

        return this;
    },

    val: function (value) {
        if (value === undefined) return this[0] && jCube.getValue(this[0]);

        return this.each(function (i, ele) {
            if (ele.tagName === 'SELECT') {
                var eleValue_1 = jCube.isArray(value) ? value : value === null ? [] : [value];
                jCube.each(ele.options, function (i, option) {
                    option.selected = eleValue_1.indexOf(option.value) >= 0;
                });
            } else {
                ele.value = value === null ? '' : value;
            }
        });
    },

    // For internal use only.
    // Behaves like an Array's method, not like a App method.
    push: vars.push,
    sort: vars.arr.sort,
    splice: vars.arr.splice
};

// jCube.prototype = jCube.fn;
jCube.fn.init.prototype = jCube.fn;

jCube.extend = jCube.fn.extend = function() {
    var options, name, src, copy, copyIsArray, clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;

    // Handle a deep copy situation
    if ( typeof target === "boolean" ) {
        deep = target;

        // Skip the boolean and the target
        target = arguments[ i ] || {};
        i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if ( typeof target !== "object" && !jCube.isFunction(target) ) {
        target = {};
    }

    // Extend App itself if only one argument is passed
    if ( i === length ) {
        target = this;
        i--;
    }

    for ( ; i < length; i++ ) {
        // Only deal with non-null/undefined values
        if ( (options = arguments[ i ]) != null ) {
            // Extend the base object
            for ( name in options ) {
                src = target[ name ];
                copy = options[ name ];

                // Prevent never-ending loop
                if ( target === copy ) {
                    continue;
                }

                // Recurse if we're merging plain objects or arrays
                if ( deep && copy && ( jCube.isPlainObject(copy) || (copyIsArray = jCube.isArray(copy)) ) ) {
                    if ( copyIsArray ) {
                        copyIsArray = false;
                        clone = src && jCube.isArray(src) ? src : [];

                    } else {
                        clone = src && jCube.isPlainObject(src) ? src : {};
                    }

                    // Never move original objects, clone them
                    target[ name ] = jCube.extend( deep, clone, copy );

                    // Don't bring in undefined values
                } else if ( copy !== undefined ) {
                    target[ name ] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
};

/**
 * $.method()
 */
jCube.extend({
    // Unique for each copy of jQuery on the page
    _expando: name + ( vars.version + Math.random() ).replace( /\D/g, "" ),
    // _containers: {},
    _cache: {},
    _guid: 0,
    _version: vars.version,

    isReady: true,

    error: function( msg ) {
        throw new Error( msg );
    },

    noop: function() {},

    // isHidden: function (obj) {
    //     return this.computeStyle(obj, 'display') === 'none';
    // },

    getValue: function (ele) {
        if (ele.multiple) return jCube.h.pluck(filter.call(ele.options, function (option) {
            return option.selected && !option.disabled && !option.parentNode.disabled;
        }), 'value');
        return ele.value || '';
    },

    computeStyle: function (element, prop, isVariable) {
        if (!jCube.isElement(element) || !prop) return;
        var style = vars.win.getComputedStyle(element, null);
        return prop ? isVariable ? style.getPropertyValue(prop) || undefined : style[prop] : style;
    },

    getDefaultDisplay: function (tagName) {
        if (vars.defaultDisplay[tagName]) return vars.defaultDisplay[tagName];

        var ele = vars.doc.createElement(tagName);
        vars.doc.body.appendChild(ele);

        var display = this.computeStyle(ele, 'display');
        vars.doc.body.removeChild(ele);

        return vars.defaultDisplay[tagName] = display !== 'none' ? display : 'block';
    },


    /**
     * Evaluates a script in a global context
     */
    globalEval: function( code ) {
        var script, indirect = eval;

        code = jCube.trim( code );

        if ( code ) {
            // If the code includes a valid, prologue position
            // strict mode pragma, execute code by injecting a
            // script tag into the document.
            if ( code.indexOf("use strict") === 1 ) {
                script = vars.doc.createElement("script");
                script.text = code;
                vars.doc.head.appendChild( script ).parentNode.removeChild( script );
            } else {
                // Otherwise, avoid the DOM node creation, insertion
                // and removal by using an indirect global eval
                indirect( code );
            }
        }
    },

    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE9-11+
    // Microsoft forgot to hump their vendor prefix (#9572)
    // camelCase: function( string ) {
    //     return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
    // },

    nodeName: function( elem, name ) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    },

    // results is for internal usage only
    makeArray: function( arr, results ) {
        var ret = results || [];

        if ( arr != null ) {
            if ( jCube.isArraylike( Object(arr) ) ) {
                jCube.merge( ret,
                    typeof arr === "string" ?
                        [ arr ] : arr
                );
            } else {
                vars.push.call( ret, arr );
            }
        }

        return ret;
    },

    merge: function( first, second ) {
        var len = +second.length,
            j = 0,
            i = first.length;

        for ( ; j < len; j++ ) {
            first[ i++ ] = second[ j ];
        }

        first.length = i;

        return first;
    },

    assign: function(target, vars){
        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    },

    grep: function( elems, callback, invert ) {
        var callbackInverse,
            matches = [],
            i = 0,
            length = elems.length,
            callbackExpect = !invert;

        // Go through the array, only saving the items
        // that pass the validator function
        for ( ; i < length; i++ ) {
            callbackInverse = !callback( elems[ i ], i );
            if ( callbackInverse !== callbackExpect ) {
                matches.push( elems[ i ] );
            }
        }

        return matches;
    },

    // arg is for internal usage only
    map: function( elems, callback, arg ) {
        var value,
            i = 0,
            length = elems.length,
            isArray = jCube.isArraylike( elems ),
            ret = [];

        // Go through the array, translating each of the items to their new values
        if ( isArray ) {
            for ( ; i < length; i++ ) {
                value = callback( elems[ i ], i, arg );

                if ( value != null ) {
                    ret.push( value );
                }
            }

            // Go through every key on the object,
        } else {
            for ( i in elems ) {
                value = callback( elems[ i ], i, arg );

                if ( value != null ) {
                    ret.push( value );
                }
            }
        }

        // Flatten any nested arrays
        return vars.concat.apply( [], ret );
    },

    /**
     * http://qaru.site/questions/5739/how-to-get-the-value-from-the-get-parameters
     */
    parseQueryString: function (query) {
        var vars = query.split("&");
        var query_string = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = decodeURIComponent(pair[1]);
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                query_string[pair[0]] = [query_string[pair[0]], decodeURIComponent(pair[1])];
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return query_string;
    },

    camelCase: function (str, all_upper) {
        all_upper = all_upper || false;
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return (index === 0 && !all_upper) ? word.toLowerCase() : word.toUpperCase();
            // return word.toUpperCase();
        }).replace(/(\s|-)+/g, '');
    },

    now: Date.now,

    getSuffixedValue: function (prop, value, isVariable) {
        if (isVariable === void 0) {
            isVariable = this.isCSSVariable(prop);
        }

        return !isVariable && !vars.numericProps[prop] && this.isNumeric(value) ? value + "px" : value;
    },

    isCSSVariable: function (prop) {
        return vars.cssVariableRe.test(prop);
    },

    getPrefixedProp: function (prop, isVariable) {
        var prefixedProps = {},
            style = vars.div.style,
            vendorsPrefixes = ['webkit', 'moz', 'ms', 'o'];

        if (isVariable === void 0) {
            isVariable = this.isCSSVariable(prop);
        }

        if (isVariable) return prop;

        if (!prefixedProps[prop]) {
            var propCC = this.camelCase(prop),
                propUC = "" + propCC.charAt(0).toUpperCase() + propCC.slice(1),
                props = (propCC + " " + vendorsPrefixes.join(propUC + " ") + propUC).split(' ');

            this.each(props, function (i, p) {
                if (p in style) {
                    prefixedProps[prop] = p;
                    return false;
                }
            });
        }

        return prefixedProps[prop];
    },

    // evalScripts: function (node) {
    //     var collection = cash(node);
    //     collection.filter('script').add(collection.find('script')).each(function (i, ele) {
    //         if (!ele.src && vars.scriptTypeRe.test(ele.type)) {
    //             // The script type is supported
    //             if (ele.ownerDocument.documentElement.contains(ele)) {
    //                 // The element is attached to the DOM // Using `documentElement` for broader browser support
    //                 eval(ele.textContent.replace(vars.HTMLCDATARe, ''));
    //             }
    //         }
    //     });
    // },

    scrollElement: function( elem, method, prop, val ) {
        var win;
        if ( this.isWindow( elem ) ) {
            win = elem;
        } else if ( elem.nodeType === Node.DOCUMENT_NODE ) {
            win = elem.defaultView;
        }

        if ( val === undefined ) {
            return win ? win[ prop ] : elem[ method ];
        }

        if ( win ) {
            win.scrollTo(
                !top ? val : win.pageXOffset,
                top ? val : win.pageYOffset
            );

        } else {
            elem[ method ] = val;
        }
    }
});

jCube.find = function(selector, context) {
    if (context === void 0) {
        context = vars.doc;
    }

    return !jCube.isDocument(context) && !jCube.isElement(context) ?
        [] : vars.classRe.test(selector) ?
            context.getElementsByClassName(selector.slice(1)) : vars.tagRe.test(selector) ?
                context.getElementsByTagName(selector) : context.querySelectorAll(selector);
};

jCube.extend({

    getData: function (ele, key) {
        var value = ele.dataset ? ele.dataset[key] || ele.dataset[this.camelCase(key)] : ele.getAttribute("data-" + key);
        try {
            return JSON.parse(value);
        } catch (arr) {
        }

        return value;
    },

    setData: function (ele, key, value) {
        try {
            value = JSON.stringify(value);
        } catch (arr) {
        }

        if (ele.dataset) {
            ele.dataset[this.camelCase(key)] = value;
        } else {
            ele.setAttribute("data-" + key, value);
        }
    },

    data: function (ele, key, value) {
        if (value == null) {
            return this.getData(ele, key);
        }

        this.setData(ele, key, value);
    }
});

/**
 * Other
 */
function each( obj, callback, args ) {
    var value,
        i = 0,
        length = obj.length,
        isArray = jCube.isArraylike( obj );

    if ( args ) {
        if ( isArray ) {
            for ( ; i < length; i++ ) {
                value = callback.apply( obj[ i ], args );

                if ( value === false ) {
                    break;
                }
            }
        } else {
            for ( i in obj ) {
                value = callback.apply( obj[ i ], args );

                if ( value === false ) {
                    break;
                }
            }
        }

        // A special, fast, case for the most common use of each
    } else {
        if ( isArray ) {
            for ( ; i < length; i++ ) {
                value = callback.call( obj[ i ], i, obj[ i ] );

                if ( value === false ) {
                    break;
                }
            }
        } else {
            for ( i in obj ) {
                value = callback.call( obj[ i ], i, obj[ i ] );

                if ( value === false ) {
                    break;
                }
            }
        }
    }

    return obj;
}
jCube.each = each;

function parseHTML(html) {
    jCube.h.initContainers();
    if (!jCube.isString(html)) return [];
    if (vars.singleTagRe.test(html)) return [vars.doc.createElement(RegExp.$1)];
    var fragment = vars.fragmentRe.test(html) && RegExp.$1,
        container = jCube._containers[fragment] || jCube._containers['*'];

    container.innerHTML = html;
    return jCube(container.childNodes).detach().get();
}
jCube.parseHTML = parseHTML;

jCube.trim = function (str, char) {
    char = char === void 0 ? " " : char === "]" ? "\\]" : char === "\\" ? "\\\\" : char;
    return str.replace(new RegExp(
        "^[" + char + "]+|[" + char + "]+$", "g"
    ), "");
};



// window.jCube = jCube;

module.exports = jCube;
// exports = jCube;
// exports.jCube = jCube;
